
export class WriteSql {
cnxCode: string;
exitStatusOnDataSent: boolean | null;
exitStatusOnFailure: boolean | null;
exitStatusOnNoDataSent: boolean | null;
query: string;
}

